import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3faadd0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "confirmation-origin"
}
const _hoisted_2 = { class: "is-internal" }
const _hoisted_3 = { class: "left-actions" }
const _hoisted_4 = { class: "right-actions" }
const _hoisted_5 = { class: "header-progress-bar" }

import { computed, ref, watch } from 'vue'

import Profiles from '@/popup/components/views/Confirmation/Profiles.vue'
import Origin from '@/popup/components/views/Confirmation/Origin.vue'
import { Transaction } from '@/shared/models/Transaction'
import { EXTENSION_ORIGIN } from '@/shared/config'
import { t } from '@/popup/lib/i18n'
import { ControllerDTO } from '@/business-logic/profile'
import { useProfileStore } from '@/popup/store/ProfileStore'

type Props = {
  transaction: Transaction
  isFixed?: boolean
  scrollPercentage: number
  isContractDeployment: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  props: {
    transaction: {},
    isFixed: { type: Boolean },
    scrollPercentage: {},
    isContractDeployment: { type: Boolean }
  },
  setup(__props: any) {

const props = __props
const profileIconSize = computed(() => (props.isFixed ? 'small' : 'medium'))
const isInternal = props.transaction.origin === EXTENSION_ORIGIN
const profileStore = useProfileStore()

const deviceController = ref<ControllerDTO>()
watch(
  () => profileStore.deviceController,
  async newDeviceController => {
    deviceController.value = newDeviceController
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", {
    ref: "headerRef",
    class: _normalizeClass(`confirmation-header ${_ctx.isFixed ? 'is-fixed' : ''}`)
  }, [
    isInternal
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(deviceController.value?.name ||
          _unref(t)('profile.create.authorized_apps.browser_extension_display_name')), 1 /* TEXT */)
        ]))
      : (_openBlock(), _createBlock(Origin, {
          key: 1,
          class: "confirmation-origin",
          origin: _ctx.transaction.origin
        }, null, 8 /* PROPS */, ["origin"])),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "leftActions")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _renderSlot(_ctx.$slots, "rightActions")
    ]),
    _createVNode(Profiles, {
      class: _normalizeClass(`confirmation-profiles column ${_ctx.isFixed ? 'is-fixed' : ''}`),
      from: _ctx.transaction.from,
      "profile-icon-size": profileIconSize.value,
      to: _ctx.transaction.to,
      "is-contract-deployment": _ctx.isContractDeployment,
      "truncate-name-length": _ctx.isFixed ? 5 : 10,
      "truncate-address-length": _ctx.isFixed ? 4 : 8
    }, null, 8 /* PROPS */, ["class", "from", "profile-icon-size", "to", "is-contract-deployment", "truncate-name-length", "truncate-address-length"]),
    _renderSlot(_ctx.$slots, "headerBottom", { isFixed: _ctx.isFixed }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "progress-bar",
        style: _normalizeStyle({ width: `${_ctx.scrollPercentage}%` })
      }, null, 4 /* STYLE */)
    ])
  ], 2 /* CLASS */))
}
}

})